<template>
  <nav role="navigation" class="navwrapper">
    <transition-group 
      name="breadcrumbnav" 
      @before-leave="beforeLeave"
      @before-enter="beforeEnter"
      @after-enter="afterEnter"
      tag="div" 
      appear 
      class="breadv1" 
      v-cloak>
      <div class="breadElement"
        :style="{ transitionDelay: (index * 0.2) + 's' }"
        :class="{ 'lastel': index == breadcrumb.length - 1 }"
        v-for="(el, index) in breadcrumb" :key="el.text">
        <template v-if="!el.isRoute">
          <a :href="el.href" v-cloak>
            {{ removeSlashes(el.text) }}
          </a>
        </template>
        <template v-else>
          <RouterLink :to="el.path" v-if="index != breadcrumb.length - 1">
            {{ removeSlashes(el.text) }}
          </RouterLink>
          <a v-cloak v-else>{{ removeSlashes(el.text) }}</a>
        </template>
      </div>
    </transition-group>
  </nav>
</template>

<script>
import { ref } from "vue";
import { RouterLink } from 'vue-router';

export default {
  props: ["breadcrumb"],
  setup(props) {

    const removeSlashes = title => title.replaceAll("/", "-");

    const initialRender = ref(true);

    const beforeLeave = el => {
      el.style.transition = 'opacity 0s ease';
      el.style.opacity = 0;
    }

    const beforeEnter = (el) => {
      if (!initialRender.value) {
        el.style.transitionDelay = '0.2s';
      }
    };

    const afterEnter = () => {
      initialRender.value = false;
    };

    const getTransitionStyle = (index) => {
      return initialRender.value ? 
        { transitionDelay: `${index * 0.2}s` } : 
        { transitionDelay: '0.2s' };
    };

    return {
      getTransitionStyle,
      afterEnter,
      beforeEnter,
      beforeLeave,
      removeSlashes
    }
  }
}
</script>

<style scoped>
.navwrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 25px;
}

.brcrumbs {
  margin: 0 0 1rem;
  list-style: none;
  height: 24px;
}

.brcrumbs li {
  float: left;
  color: #0a0a0a;
  cursor: default;
  font-family: Montserrat;
  text-transform: none;
}

.brcrumbs li a {
  color: #a7a5a5;
  white-space: no-wrap;
}

.brcrumbs li:not(:last-child):after {
  position: relative;
  top: 1px;
  margin: 0 .75rem;
  opacity: 1;
  content: "/";
  color: #cacaca;
}

/*#region novo css*/

.navwrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 25px;
}

.breadv1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 0 1rem;
}

.breadv1 .breadElement {
  color: #0a0a0a;
  cursor: default;
  font-family: Montserrat;
  text-transform: none;
  font-size: 15px;
}

.breadv1 .breadElement a {
  color: #a7a5a5;
  white-space: nowrap;
}

.breadv1 .breadElement:after {
  position: relative;
  top: 1px;
  margin: 0 .75rem;
  opacity: 1;
  content: "/";
  color: #cacaca;
}

.breadv1 .breadElement.lastel:after {
  content: "";
}

@media (min-width: 768px) and (max-width: 1024px) {
  .breadv1 {
    font-size: 14px;
  }
}

@media (max-width: 767px) {
  .breadv1 .breadElement {
    display: none;
  }
}

.breadv1.whitenav .breadElement a {
  color: white;
}

.breadcrumbnav-enter-active {
  transition: opacity 1.5s ease;
}

.breadcrumbnav-enter-from {
  opacity: 0;
}

.breadcrumbnav-leave-active {
  transition: opacity 0s ease;
}

.breadcrumbnav-leave-to {
  opacity: 0;
}

</style>